import React from "react";
import PaperWorkNeeded from "../../PicesForPages/PaperWorkNeeded.png";
import FreeConsultation from "../Form/FreeConsultation";

function PaperWork() {
  return (
    <div className="purchaseParent">
      <div className="purchasetopParent">
        <img
          fetchPriority="high"
          loading="eager"
          src={PaperWorkNeeded}
          alt="NewsPaperImage"
          className="background-video"
        />
        <div className="purchasetopBox">
          {/* The existing Purchase span */}
          <span>Necessary Paperwork</span>
        </div>
      </div>
      <div className="purchaseBottomParent">
        <div className="purchaseBottomBox">
          <div className="purchaseBottomLeftBox">
            <span className="purchaseBottomLeftContent">
              When applying for a loan, you’ll be required to provide a
              comprehensive overview of your financial profile to the lender.
              The lender will obtain your credit report from a credit bureau and
              verify the details included in your application. Please be
              prepared to submit the following:
            </span>
            <ul className="purchaseBottomLeftUL paperworkBottomLeftUL">
              <li>Social Security numbers for you and any co-borrowers</li>
              <li>
                Recent bank statements for checking and savings accounts
                covering the past two months
              </li>
              <li>
                Documentation of additional assets such as stocks, bonds, or
                retirement accounts (e.g., 401k or 403b)
              </li>
              <li>Your latest pay stubs</li>
              <li>
                W-2 forms or tax returns from the past two years to validate
                your income and employment history
              </li>
              <li>
                The name and contact information of a reference who can verify
                your employment
              </li>
              <li>
                A record of your residential history for the past two years
              </li>
              <li>
                A fully executed sales agreement for the purchase of a new home
              </li>
              <li>
                Homeowners association contact details, if the property is a
                condominium or part of an HOA
              </li>
            </ul>
            <div className="purchaseBottomLeftButton">
              <a
                href="https://vidhimortgage.my1003app.com/"
                target="_blank"
                rel="noreferrer"
                className="purchaseBottomLeftButtonLink"
              >
                Apply Now
              </a>
            </div>
          </div>
          <FreeConsultation />
        </div>
      </div>
    </div>
  );
}

export default PaperWork;
